import { render, staticRenderFns } from "./ContactInformation.vue?vue&type=template&id=1f37fce6&scoped=true&"
import script from "./ContactInformation.vue?vue&type=script&lang=js&"
export * from "./ContactInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f37fce6",
  null
  
)

export default component.exports